var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown-plus-select',_vm._b({attrs:{"options":_vm.options},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}},'dropdown-plus-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }